//import { Navigate } from "react-router-dom";
//import ApiService from "../core/services/ApiService";
//import { routes } from "./provider/routes.utlis";

export const weekDays = (Id) => {
  let day = parseInt(Id);
  if (day === 1) return "S";
  else if (day === 2) return "M";
  else if (day === 3) return "T";
  else if (day === 4) return "W";
  else if (day === 5) return "Th";
  else if (day === 6) return "F";
  else if (day === 7) return "Sa";
};

export const Loyalty = (Id) => {
  let val = parseInt(Id);
  if (val === 1) return "Offer & Discounts";
  else if (val === 2) return "Subscription Plans";
  else if (val === 3) return "Giveaways";
  else if (val === 4) return "Contests";
};

export const status = (Id) => {
  let statusId = parseInt(Id);
  if (statusId === 0) return "Pending";
  else if (statusId === 1) return "Active";
  else if (statusId === 2) return "Inactive";
  else if (statusId === 3) return "Suspended";
  else if (statusId === 4) return "Deleted";
};

export const bookingStatus = (Id) => {
  let statusId = parseInt(Id);
  if (statusId === 0) return "Pending";
  else if (statusId === 1) return "Confirm";
  else if (statusId === 3) return "Rejected";
};

export const userType = (Id) => {
  let statusId = parseInt(Id);
  if (statusId === 4) return "Admin";
  else if (statusId === 1) return "User";
  else if (statusId === 2) return "Provider";
  else if (statusId === 3) return "Staff";
};

export const billingType = (Id) => {
  let statusId = Id;
  if (statusId === "MONTHLY") return 1;
  else if (statusId === "QUARTERLY") return 2;
  else if (statusId === "HALF_YEARLY") return 3;
  else if (statusId === "YEARLY") return 4;
};

export const countryCodes = [
  { code: "+1", label: "🇺🇸 USA" },
  { code: "+44", label: "🇬🇧 UK" },
  { code: "+91", label: "🇮🇳 India" },
  { code: "+61", label: "🇦🇺 Australia" },
  { code: "+81", label: "🇯🇵 Japan" },
];


export const LIMIT = 10;
export const communityLIMIT = 6;
export const providerLIMIT = 3;
export const adsLIMIT = 5;
export const CommonMiles = "500"; //  500 Miles
export const LogoFile = 1; //  2MB
export const SingleFile = 2; //  2MB
export const MultipleFile = 5; //  5MB
export const GeolocationApiKey = process.env.REACT_APP_GEOLOCATION_API_KEY;
export const VapidKey = process.env.REACT_APP_VAPID_KEY;
export const DefaultMoney = 1; //  1$

export const totalPageCalculator = (total, limit) => {
  const pages = [];
  for (let x = 1; x <= Math.ceil(total / limit); x++) {
    pages.push(x);
  }
  return pages;
};

export const sortAsc = (arr) => {
  return [...arr].sort((a, b) => Number(a) - Number(b));
}

export const milesOptions = [
  { label: "10 Miles", value: "10" },
  { label: "20 Miles", value: "20" },
  { label: "30 Miles", value: "30" },
  { label: "50 Miles", value: "50" },
  { label: "100 Miles", value: "100" },
  { label: "200 Miles", value: "200" },
  { label: "300 Miles", value: "300" },
  { label: "500 Miles", value: "500" },
];



